import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Save, Loader2, KeyRound, X } from "lucide-react";

const API = "/api";

const ChangePasswordPanel = ({ onClose }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error("Le password non coincidono");
      return;
    }
    if (newPassword.length < 6) {
      toast.error("La nuova password deve avere almeno 6 caratteri");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/admin/change-password`, {
        current_password: currentPassword,
        new_password: newPassword,
      });
      toast.success("Password aggiornata con successo");
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore nel cambio password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-testid="change-password-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 sm:p-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2" style={{ fontFamily: "Outfit, sans-serif" }}>
            <KeyRound className="w-5 h-5 text-emerald-600" /> Cambia Password
          </h2>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600" data-testid="change-password-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Password attuale</label>
            <Input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Inserisci la password attuale" className="h-11 rounded-xl" data-testid="current-password-input" />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Nuova password</label>
            <Input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Almeno 6 caratteri" className="h-11 rounded-xl" data-testid="new-password-input" />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Conferma nuova password</label>
            <Input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Ripeti la nuova password" className="h-11 rounded-xl" data-testid="confirm-password-input" />
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose}
              className="flex-1 border border-slate-200 text-slate-600 rounded-xl py-2.5 text-sm font-medium hover:bg-slate-50 transition-colors"
              data-testid="change-password-cancel">Annulla</button>
            <button type="submit" disabled={loading || !currentPassword || !newPassword || !confirmPassword}
              className="flex-1 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl py-2.5 text-sm font-bold disabled:opacity-50 flex items-center justify-center gap-2 transition-colors"
              data-testid="change-password-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Salva
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPanel;
